<template>
  <div
    class="checkbox-input"
    :class="[
      { [$class('loading')]: loading },
    ]"
  >
    <input
      :id="id"
      v-model="localModelValue"
      class="checkbox-input__input visually-hidden"
      :class="{ [$class('disabled')]: disabled }"
      :disabled="disabled || loading"
      :name="name"
      type="checkbox"
      @change="updateVModel(localModelValue)"
    >

    <label
      class="checkbox-input__label text-body-m-regular"
      :for="id"
    >
      <span
        class="checkbox-input__label-text"
        v-html="label"
      />
    </label>
  </div>
</template>

<script>

/**
 * Vue: Checkbox input (checkbox-input)
 * -----------------------------------------------------------------------------
 * Checkbox input utility component.
 *
 * @param {Boolean} [disabled] - Input is disabled.
 * @param {String} id - ID for input.
 * @param {String} label - Input label.
 * @param {Boolean} [loading] - Loading state.
 * @param {Boolean} modelValue - Current value provided by v-model.
 * @param {String} [name] - Input name attribute.
 *
 * @emits update:model-value - Emit v-model update event.
 *
 */
export default {
  name: 'CheckboxInput',

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: '',
      required: true,
    },
    label: {
      type: String,
      default: '',
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: Boolean,
      default: false,
      required: true,
    },
    name: {
      type: String,
      default: '',
    },
  },

  emits: {
    'update:model-value': () => true,
  },

  data() {
    return {
      localModelValue: false,
    }
  },

  watch: {

    /**
     * Watch v-model value to update local value.
     */
    modelValue() {
      this.localModelValue = this.modelValue
    },
  },

  mounted() {
    this.localModelValue = this.modelValue
  },

  methods: {

    /**
     * Emit update v-model event.
     * @param {Boolean} value - Updated value.
     */
    updateVModel(value) {
      this.$emit('update:model-value', value)
    },
  },
}
</script>

<style lang="scss">
@import './checkbox-input';
</style>
